// extracted by mini-css-extract-plugin
module.exports = {"tvFavoriteButton":"FavoriteToggleButton_tvFavoriteButton__t7MoR","active":"FavoriteToggleButton_active__bZujj","disabled":"FavoriteToggleButton_disabled__yGl00"};